<div class="content" [formGroup]="form">
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.ASSIGN_SALES_TEAM.DESCRIPTION' | translate }}
  </div>
  <div class="market-warning">
    <glxy-alert type="info">
      {{ 'AUTOMATIONS.EDITOR.TASKS.ASSIGN_SALESPERSON.MARKET_WARNING' | translate }}
    </glxy-alert>
  </div>
  <div class="control-container">
    <ng-container *ngIf="(dontShowSalesTeamSelector$ | async) === false">
      <automata-automation-replacement-chips
        label="AUTOMATIONS.EDITOR.TASKS.ASSIGN_SALES_TEAM.SALES_TEAM"
        [dataService]="salesTeamSelectorService"
        [formControl]="salesTeamFormControl"
        [isRequired]="true"
        [multiple]="false"
        [supportDataPassing]="false"
        (finishedInitialLoading)="finishedLoadingSelector()"
      ></automata-automation-replacement-chips>
    </ng-container>
    <ng-container *ngIf="(dontShowSalesTeamSelector$ | async) === true">
      <glxy-form-field>
        <glxy-label>
          {{ 'AUTOMATIONS.EDITOR.TASKS.ASSIGN_SALES_TEAM.SALES_TEAM' | translate }}
        </glxy-label>
        <mat-select [disabled]="true"></mat-select>
      </glxy-form-field>
    </ng-container>
  </div>
  <div class="reassign-label">
    {{ 'AUTOMATIONS.EDITOR.TASKS.ASSIGN_SALES_TEAM.REASSIGN_SALESPERSON_DESCRIPTION' | translate }}
  </div>
  <div class="control-container">
    <mat-radio-group [formControl]="shouldReassignFormControl">
      <div class="reassign-option">
        <mat-radio-button [value]="false">
          {{ 'AUTOMATIONS.EDITOR.TASKS.ASSIGN_SALES_TEAM.KEEP_ORIGINAL_SALESPERSON' | translate }}
        </mat-radio-button>
      </div>
      <div>
        <mat-radio-button [value]="true">
          {{ 'AUTOMATIONS.EDITOR.TASKS.ASSIGN_SALES_TEAM.REPLACE_SALESPERSON' | translate }}
        </mat-radio-button>
      </div>
      <mat-hint>
        <div class="hint">
          {{ 'AUTOMATIONS.EDITOR.TASKS.ASSIGN_SALES_TEAM.REPLACE_SALESPERSON_HINT' | translate }}
        </div>
      </mat-hint>
    </mat-radio-group>
  </div>
</div>
